import React, { useState, useEffect } from 'react';
import { Button, Card } from 'react-bootstrap'

const PageStep = props => {

    const [step, setStep] = useState(1);

    useEffect(() => {
        setStep(parseInt(props.step))
    }, []);

    return (
        <div className="page-step">

            { step === 1 ? (
                <div className="wizard">
                    <div className="wizard-inner">
                        <div className="connecting-line">
                            <div className="line-1"></div>
                        </div>
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">1 </span><span className="top">เลือกเรื่องราว</span></a>
                                {/* <a href="#"><span className="round-tab">1 </span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-1.png" /></span><span className="bottom">เลือกเรื่องราว</span></a> */}
                            </li>
                            <li role="presentation" className="disabled">
                                <a href="#"><span className="round-tab">2</span> <span className="top">ดูตัวอย่าง</span></a>
                                {/* <a href="#"><span className="round-tab">2</span> <span className="top"><img className="step-img" src="/images/process-flow/inactive-step-2.png" /></span><span className="bottom">ดูตัวอย่าง</span></a> */}
                            </li>
                            <li role="presentation" className="disabled">
                                <a href="#"><span className="round-tab">3</span> <span className="top">กิจกรรม</span></a>
                                {/* <a href="#"><span className="round-tab">3</span> <span className="top"><img className="step-img" src="/images/process-flow/inactive-step-3.png" /></span><span className="bottom">กิจกรรม</span></a> */}
                            </li>
                            <li role="presentation" className="disabled">
                                <a href="#"><span className="round-tab">4</span> <span className="top">เสร็จสิ้น</span></a>
                                {/* <a href="#"><span className="round-tab">4</span> <span className="top"><img className="step-img" src="/images/process-flow/inactive-step-4.png" /></span><span className="bottom">เสร็จสิ้น</span></a> */}
                            </li>
                        </ul>
                    </div>
                </div>
            ) : (step === 2) ? (
                <div className="wizard">
                    <div className="wizard-inner">
                        <div className="connecting-line">
                            <div className="line line-2"></div>
                        </div>
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">1 </span> <span className="top">เลือกเรื่องราว</span></a>
                                {/* <a href="#"><span className="round-tab">1 </span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-1.png" /></span><span className="bottom">เลือกเรื่องราว</span></a> */}
                            </li>
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">2</span> <span className="top">ดูตัวอย่าง</span></a>
                                {/* <a href="#"><span className="round-tab">2</span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-2.png" /></span><span className="bottom">ดูตัวอย่าง</span></a> */}
                            </li>
                            <li role="presentation" className="disabled">
                                <a href="#"><span className="round-tab">3</span> <span className="top">กิจกรรม</span></a>
                                {/* <a href="#"><span className="round-tab"></span> <span className="top"><img className="step-img" src="/images/process-flow/inactive-step-3.png" /></span><span className="bottom">กิจกรรม</span></a> */}
                            </li>
                            <li role="presentation" className="disabled">
                                <a href="#"><span className="round-tab">4</span> <span className="top">เสร็จสิ้น</span></a>
                                {/* <a href="#"><span className="round-tab"></span> <span className="top"><img className="step-img" src="/images/process-flow/inactive-step-4.png" /></span><span className="bottom">เสร็จสิ้น</span></a> */}
                            </li>
                        </ul>
                    </div>
                </div>
            ) : (step === 3) ? (
                <div className="wizard">
                    <div className="wizard-inner">
                        <div className="connecting-line">
                            <div className="line line-3"></div>
                        </div>
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">1 </span> <span className="top">เลือกเรื่องราว</span></a>
                                {/* <a href="#"><span className="round-tab">1 </span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-1.png" /></span><span className="bottom">เลือกเรื่องราว</span></a> */}
                            </li>
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">2</span> <span className="top">ดูตัวอย่าง</span></a>
                                {/* <a href="#"><span className="round-tab">2</span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-2.png" /></span><span className="bottom">ดูตัวอย่าง</span></a> */}
                            </li>
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">3</span> <span className="top">กิจกรรม</span></a>
                                {/* <a href="#"><span className="round-tab">3</span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-3.png" /></span><span className="bottom">กิจกรรม</span></a> */}
                            </li>
                            <li role="presentation" className="disabled">
                                <a href="#"><span className="round-tab">4</span> <span className="top">เสร็จสิ้น</span></a>
                                {/* <a href="#"><span className="round-tab">4</span> <span className="top"><img className="step-img" src="/images/process-flow/inactive-step-4.png" /></span><span className="bottom">เสร็จสิ้น</span></a> */}
                            </li>
                        </ul>
                    </div>
                </div>
            ) : (step === 4) ? (
                <div className="wizard">
                    <div className="wizard-inner">
                        <div className="connecting-line">
                            <div className="line line-4"></div>
                        </div>
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">1 </span> <span className="top">เลือกเรื่องราว</span></a>
                                {/* <a href="#"><span className="round-tab">1 </span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-1.png" /></span><span className="bottom">เลือกเรื่องราว</span></a> */}
                            </li>
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">2</span> <span className="top">ดูตัวอย่าง</span></a>
                                {/* <a href="#"><span className="round-tab">2</span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-2.png" /></span><span className="bottom">ดูตัวอย่าง</span></a> */}
                            </li>
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">3</span> <span className="top">กิจกรรม</span></a>
                                {/* <a href="#"><span className="round-tab">3</span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-3.png" /></span><span className="bottom">กิจกรรม</span></a> */}
                            </li>
                            <li role="presentation" className="active">
                                <a href="#"><span className="round-tab">4</span> <span className="top">เสร็จสิ้น</span></a>
                                {/* <a href="#"><span className="round-tab">4</span> <span className="top"><img className="step-img" src="/images/process-flow/active-step-4.png" /></span><span className="bottom">เสร็จสิ้น</span></a> */}
                            </li>
                        </ul>
                    </div>
                </div>
            ) : (
                                ''
                            )
            }
        </div>
    )
}

export default PageStep